import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AnnouncementList from "./AnnouncementList";
import AnnouncementCreate from "./AnnouncementCreate";
import AnnouncementDetail from "./AnnouncementDetail";
import AnnouncementEdit from "./AnnouncementEdit";
import ProtectedRoutes from "components/common/routing/ProtectedRoutes";

const AnnouncementsIndex = () => {
  return (
    <Routes>
      <Route index element={
        <ProtectedRoutes permissionKey="Announcements-view">
          <AnnouncementList />
        </ProtectedRoutes>
      } />

      <Route path="create" element={
        <ProtectedRoutes permissionKey="Announcements-manage">
          <AnnouncementCreate />
        </ProtectedRoutes>
      } />

      <Route path=":id/edit" element={
        <ProtectedRoutes permissionKey="Announcements-manage">
          <AnnouncementEdit />
        </ProtectedRoutes>
      } />

      <Route path=":id" element={
        <ProtectedRoutes permissionKey="Announcements-view">
          <AnnouncementDetail />
        </ProtectedRoutes>
      } />

      <Route path="*" element={<Navigate to="." />} />
    </Routes>
  );
};

export default AnnouncementsIndex;
